import Color from 'color';

import type {WithThemeProp} from '../theme';
import type {ColorThemeID, ThemeAndAnyKnownColor} from '../theme/colors';

import {getColor} from './getColor';

export type LighteningWeight = 'light' | 'medium' | 'regular' | 'strong';

const getMixRatio = (weight: LighteningWeight, themeId: ColorThemeID) => {
  switch (weight) {
    case 'light':
      return 0.3;
    case 'regular':
      return 0.5;
    case 'medium':
      switch (themeId) {
        case 'dark':
          return 0.5;
        default:
          return 0.75;
      }
    case 'strong':
      switch (themeId) {
        case 'dark':
          return 0.5;
        default:
          return 0.9;
      }
    default:
      return 0.5;
  }
};

const getMixColor = (themeId: ColorThemeID) => {
  switch (themeId) {
    case 'dark':
      return 'black';
    default:
      return 'white';
  }
};

export const getLighteningColor =
  (color: ThemeAndAnyKnownColor, weight: LighteningWeight) =>
  <ComponentProps extends WithThemeProp>(p: ComponentProps) => {
    const themeColor = getColor(color)(p);

    const ratio = getMixRatio(weight, p.theme.id);
    const mixColor = getMixColor(p.theme.id);

    return Color(themeColor).mix(Color(mixColor), ratio).toString();
  };
